import React, { useEffect, useState } from "react";
import logo from "../assets/images/logo.png";

const TRACK_LENGTH = 112;

const EntryScreenLoader = () => {
  const [busPosition, setBusPosition] = useState(-12);
  const [loadingDots, setLoadingDots] = useState(".");

  useEffect(() => {
    const busTimer = window.setInterval(() => {
      setBusPosition((prev) => (prev >= TRACK_LENGTH ? -12 : prev + 1));
    }, 45);

    const textTimer = window.setInterval(() => {
      setLoadingDots((prev) => (prev.length >= 3 ? "." : `${prev}.`));
    }, 450);

    return () => {
      window.clearInterval(busTimer);
      window.clearInterval(textTimer);
    };
  }, []);

  return (
    <div
      className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-[#120f0f] px-6 text-center"
      style={{
        backgroundImage:
          "linear-gradient(rgba(217,162,33,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(217,162,33,0.07) 1px, transparent 1px), radial-gradient(circle at center, rgba(217,162,33,0.12) 0%, rgba(18,15,15,0) 42%)",
        backgroundSize: "60px 60px, 60px 60px, 100% 100%",
        backgroundPosition: "center center, center center, center center",
      }}
    >
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#201813]/75 to-transparent" />

      <div
        className="relative z-10 flex w-full max-w-4xl flex-col items-center"
        style={{transform: "scale(0.70)",transformOrigin: "center", }}>
              <div
          className="flex h-40 w-40 items-center justify-center rounded-[2rem] border border-[#8f7123] bg-[#171313]"
          style={{ boxShadow: "0 0 0 1px rgba(217,162,33,0.1), 0 0 48px rgba(217,162,33,0.24)" }}
        >
          <div className="flexitems-center justify-center rounded-full  ">
            <img src={logo} alt="Lewoo Lite" className="h-full w-full object-contain" />
          </div>
        </div>

        <h1
          className="mt-12 text-5xl font-black tracking-[-0.04em] md:text-7xl"
          style={{
            background: "linear-gradient(90deg, #f4c53b 0%, #ff9d39 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
         Lewoo Lite
        </h1>

        <p className="mt-6 text-xl text-[#8c8581] md:text-2xl">Suivi en temps reel</p>

        <div className="mt-10 inline-flex items-center gap-4 rounded-full border border-[#7a6221] bg-[#2a2116]/85 px-8 py-4 text-2xl font-bold text-[#f3c741] shadow-[0_0_18px_rgba(217,162,33,0.14)]">
          <span className="h-3.5 w-3.5 rounded-full bg-[#f3c741] shadow-[0_0_10px_rgba(243,199,65,0.8)]" />
          <span>Tracking en direct</span>
        </div>

        <div className="mt-28 flex w-full max-w-md flex-col items-center">
          <div className="relative h-12 w-full">
            <div className="absolute inset-x-0 top-1/2 h-5 -translate-y-1/2 rounded-full bg-[#5a491d]" />
            <div
              className="absolute inset-x-3 top-1/2 h-1.5 -translate-y-1/2 rounded-full"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(90deg, rgba(220,183,74,0.85) 0px, rgba(220,183,74,0.85) 14px, transparent 14px, transparent 24px)",
              }}
            />

            <div
              className="absolute top-1/2 -translate-y-[72%] transition-[left] duration-75 ease-linear"
              style={{ left: `calc(${busPosition}% - 28px)` }}
            >
              <div className="relative">
                <div className="h-8 w-16 rounded-md rounded-tr-[10px] bg-[#f4c53b]" />
                <div className="absolute right-1 top-[-5px] h-4 w-6 rounded-sm bg-[#f8e8a3]" />
                <div className="absolute left-[5px] top-[5px] h-3 w-4 rounded-sm bg-[#fff4c7]" />
                <div className="absolute left-[12px] top-[5px] h-3 w-4 rounded-sm bg-[#fff4c7]" />
                <div className="absolute left-[36px] top-[5px] h-3 w-8 rounded-sm bg-[#fff4c7]" />
                <div className="absolute left-[4px] top-[29px] h-1.5 w-[52px] rounded-full bg-[#b36628]" />
                <div className="absolute left-[6px] top-[27px] h-4 w-4 rounded-full border-[3px] border-[#a65320] bg-[#5b3e33]" />
                <div className="absolute right-[6px] top-[27px] h-4 w-4 rounded-full border-[3px] border-[#a65320] bg-[#5b3e33]" />
              </div>
            </div>
          </div>

          <p className="mt-12 text-2xl text-[#8c8581]">Chargement en cours{loadingDots}</p>
        </div>
      </div>
    </div>
  );
};

export default EntryScreenLoader;
